// extracted by mini-css-extract-plugin
export var brand = "_1t-9";
export var compact = "_1t-6";
export var extraSmall = "_1t-7";
export var icon = "_1t-0";
export var large = "_1t-4";
export var light = "_1t-1";
export var medium = "_1t-5";
export var outline = "_1t-b";
export var primaryDark = "_1t-a";
export var primaryLight = "_1t-8";
export var primaryModern = "_1t-c";
export var success = "_1t-2";
export var successSolid = "_1t-3";